/*document.addEventListener("cart:item-added", function(evt) {
    console.log("Item added to the cart"), console.log(evt.detail.product)
}), document.addEventListener("cart:updated", function(evt) {
    console.log("Cart updated"), console.log(evt.detail.cart)
}), document.addEventListener("cart:error", function(evt) {
    console.log("Cart error"), console.log(evt.detail.errorMessage)
}), document.addEventListener("quick-cart:open", function(evt) {
    console.log("Quick cart opened"), console.log(evt.detail.cart)
}), document.addEventListener("quick-cart:close", function() {
    console.log("Quick cart closed")
}), document.addEventListener("product:variant-change", function(evt) {
    console.log("Product variant changed"), console.log(evt.detail.variant)
}), document.addEventListener("product:quantity-update", function(evt) {
    console.log("Product quantity updated"), console.log(evt.detail.quantity, evt.detail.variant)
}), document.addEventListener("quickview:loaded", function() {
    console.log("Quickview loaded")
});
*/

window.checkVariantRegion = (id) => {
    var found = false;
    if(!document.getElementById('restrictionsData')) return;
    const list = document.getElementById('restrictionsData').innerText.trim().split(',');

    if(list.length > 0){
        for (const item of list) {
            if (item.startsWith(id + '|')) {
                document.querySelectorAll('.ext-prod-link')
                    .forEach(el => el.style.display = 'block');
                document.querySelectorAll('.product__controls-group-quantity')
                    .forEach(el => el.style.display = 'none');
                document.querySelectorAll('.product__price-and-ratings .product__price').forEach(el => el.style.display = 'none');
                document.querySelectorAll('.product-form__controls-group--submit')
                    .forEach(el => el.style.display = 'none');
                document.getElementById('ext-prod-link').href = item.replace(id + '|', '');
            
                found = true;
            }
        }

        if (!found) {
            document.querySelectorAll('.ext-prod-link')
                .forEach(el => el.style.display = 'none');
            document.getElementById('ext-prod-link').href = '';
            document.querySelectorAll('.product__controls-group-quantity')
                .forEach(el => el.style.display = 'block');   
            document.querySelectorAll('.product__price-and-ratings .product__price').forEach(el => el.style.display = 'flex');
            document.querySelectorAll('.product-form__controls-group--submit')
                .forEach(el => el.style.display = 'block');
        }

    }
}

